import { useSyncExternalStore } from "react";

const noop = (): void => undefined;

/**
 * Subscribe to `window.scrollY` via `useSyncExternalStore`. Throttled to
 * one notification per animation frame so rapid scroll events don't cause
 * thrash.
 */
export function useScrollY(): number {
	return useSyncExternalStore(
		(notify) => {
			let pending = false;
			const onChange = (): void => {
				if (pending) return;
				pending = true;
				requestAnimationFrame(() => {
					pending = false;
					notify();
				});
			};
			window.addEventListener("scroll", onChange, { passive: true });
			window.addEventListener("resize", onChange, { passive: true });
			return () => {
				window.removeEventListener("scroll", onChange);
				window.removeEventListener("resize", onChange);
			};
		},
		() => window.scrollY,
		() => 0,
	);
}

void noop;
